//#region import
import React, { useEffect, useState } from 'react'
import { Chip, Grid, IconButton, Popover, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { FnAxios, FnDialog } from 'utilities/utilities';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { BtnAddOnTable, BtnEditOnTable, BtnViewOnTable } from 'components/Button/ButtonTable';
import { FilterFieldInterface } from 'components/DataGrid/DataGridProps';
import { GetMenuPermission } from 'utilities/SystemFunction';
import InfoIcon from '@mui/icons-material/Info';
import { EnumStatus } from '../AdminUser/Role/RoleList';
import { BtnBack } from 'components/Button/ButtonAll';
//#endregion

const MaterialList = () => {
    const navigate = useNavigate();
    const onBack = () => navigate("/BasicInformationList");
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [loadingTable, setLoadingTable] = useState(false);
    const [sUpdateName, setUpdateName] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [arrMaterialType, setMaterialType] = useState<any>([]);
    const [arrMaterialUnit, setMaterialUnit] = useState<any>([]);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const handleViewInfo = (e) => {
        setUpdateName(e.sUpdateName);//sUpdateName
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const dataColumn: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        IsDisabled={!isPermission}
                        onClick={() => navigate(`/MaterialForm`)} id={"Add"} />
                </>
            ),
            field: "Button (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                }
            },
        },
        {
            field: "sMaterialType",
            headerName: "ประเภทวัสดุ",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            flex: 1,
            width: 220,
        },
        {
            field: "sMaterial",
            headerName: "รายการวัสดุ",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            flex: 2,
            width: 300,
        },
        {
            field: "sUnit",
            headerName: "หน่วยนับ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            flex: 0.5,
            width: 50,
        },
        {
            field: "sUpdate",
            headerName: "แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            flex: 1,
            width: 220,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
        {
            field: "sStatus",
            headerName: "สถานะ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 50,
            flex: 0.5,
            renderCell: (item) => {
                return (
                    <>
                        {EnumStatus.Active == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "rgb(22 187 68)",
                                        backgroundColor: "rgb(231 255 237)",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                        {EnumStatus.isActive == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "#f1416c",
                                        backgroundColor: "#fff5f8",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                    </>
                )
            }
        },

    ];

    const getTableMaterial = (p: PaginationInterface) => {
        setLoadingTable(true);
        let Param = {
            ...p,
        };
        AxiosFn.Post(`Material/GetTableMaterial`, Param, (result) => {
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: [...result.lstDataMaterial],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
        });
    };


    
    const getFormInitial = () => {
        AxiosFn.Get(`Material/GetFormInitial`, {}, (result) => {
            setMaterialType(result.lstMaterialType);
            setMaterialUnit(result.lstMaterialUnit);
        })
    }

    useEffect(() => {
        getTableMaterial(dataRow);
        getFormInitial();

    }, []);

    const goToEdit = (sID: string) => {
        navigate(`/MaterialForm?sID=${encodeURI(sID)}`);
    };

    //Filter Search
    const filter: FilterFieldInterface[] = [
        { sTypeFilterMode: "input", sLabel: "ชื่อรายการวัสดุ", sFieldName: "sMaterial", nGridLG: 5, nGridMD: 6, nGridSM: 6, nGridXS: 12 },
        { sTypeFilterMode: "multiselect", sLabel: "ประเภทวัสดุ", sFieldName: "lstMaterialType", optionSelect: arrMaterialType, nGridLG: 3.5, nGridMD: 3, nGridSM: 6, nGridXS: 12 },
        { sTypeFilterMode: "multiselect", sLabel: "หน่วยที่นับ", sFieldName: "lstMaterialUnit", optionSelect: arrMaterialUnit, nGridLG: 3.5, nGridMD: 3, nGridSM: 6, nGridXS: 12 },
        { sTypeFilterMode: "date", sLabel: "วันที่แก้ไขข้อมูล (เริ่มต้น)", sFieldName: "nUpdateStart", nGridLG: 3, nGridMD: 3, nGridSM: 4, nGridXS: 12 },
        { sTypeFilterMode: "date", sLabel: "วันที่แก้ไขข้อมูล (สิ้นสุด)", sFieldName: "nUpdateEnd", nGridLG: 3, nGridMD: 3, nGridSM: 4, nGridXS: 12 },
        // { sTypeFilterMode: "daterange", sLabel: "วันที่แก้ไขข้อมูล", sFieldName: "lstnUpdate", nGridLG: 6, nGridMD: 6, nGridSM: 4.5, nGridXS: 12 },
        {
            sTypeFilterMode: "select", sLabel: "สถานะ", sFieldName: "sStatus",
            optionSelect: [
                {

                    label: "ใช้งาน",
                    value: "1"
                },
                {

                    label: "ไม่ใช้งาน",
                    value: "0"
                },

            ],
            nGridLG: 2, nGridMD: 2, nGridSM: 6, nGridXS: 12
        },
    ];

    const onDelete = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`Material/RemoveDataTable`, { lstID: e }, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTableMaterial(dataRow);
                    });
                }
            });
        });
    }
    return (
        <React.Fragment>
            <Grid item xs={12} sx={{ mt: 1 }}>
                <DataGrid
                    sTableID='tb1'
                    columns={dataColumn}
                    rows={dataRow}
                    modeFilter={1}
                    onLoadData={getTableMaterial}
                    isLoading={loadingTable}
                    isHiddenToolHead={false}
                    filterField={filter}
                    isShowCheckBox={isPermission}
                    onRowSelectable={(p) => !p.row.isDelete}
                    onDelete={onDelete}
                />
            </Grid>

            <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={12} md={12}>
                        <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    </Grid>

                </Grid>

            {/* pop over */}
            <Popover
                id={`sUpdateName`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
            </Popover>
        </React.Fragment >
    )
}
export default MaterialList;

